/* eslint-disable no-restricted-globals */

export const logIn = (url: string) => {
    localStorage.setItem('reinmerker-innsyn-route-v1', window.location.href)
    localStorage.setItem(
        'reinmerker-innsyn-route-timestamp-v1',
        Date.now().toString()
    )
    location.href = url
}
